
import React,{useLayoutEffect, useState} from 'react';
import { Route, Switch } from 'react-router-dom';
import {ErrorBoundary} from 'react-error-boundary'

import SubHeader from './subheader';
import ProjectsComponent from './projects_component';
import PortabilityBannerComponent from './portability_banner';
import ErrorPortalComponent from "../../common/error_portal/ErrorPortalComponent";
import ActionTypes from '../constants';
import './App.scss';
import MessageTextDisplayComponent from './message_display_component';

/**
     * The below method set the variable usertype, regtype and campaignName in the gon object from store object
     */
 const updateGonFromStoreObject = () => {
        try {
            //@ts-ignore
            if(typeof(store) !== 'undefined') {
                //@ts-ignore
                photoOrg.config.user_Type = store.userType
                //@ts-ignore
                photoOrg.config.regType = store.regType
                //@ts-ignore
                photoOrg.config.campaignName = store.campaignName
                //An extra variable that is added for only Amz
                //@ts-ignore
                if (photoOrg.config.isAmz) {
                    //@ts-ignore
                    photoOrg.config.partnerAccountId = store.partnerAccountId
                }
            }
        }catch(e){
            //@ts-ignore
            photoOrg.clientLogger.warn({description: "PROJECTS:projects_view:updateGonFromStoreObject:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: e, err_stack: e.stack});
        }
}

const set_projects_omniture = () => {
        //Projects page related omniture info is set in the pageInfo object.
        var pageInfo = {
            pageName : 'MY Projects',
            siteServiceName : "Library",
            primaryCategory : "My Projects",
            loginState : 'YES',
            //@ts-ignore
            accountId : photoOrg.config.account_id,
            //@ts-ignore
            userType : photoOrg.config.user_Type,
            //@ts-ignore
            regType : photoOrg.config.regTyp,
            userInfo: null
        };
        pageInfo.userInfo = {
            profile:{
                profileInfo:{
                    loginState : "YES",
                    //@ts-ignore
                    userAccount: photoOrg.config.account_id,
                    customerStatus : '',
                    //@ts-ignore
                    userType:  photoOrg.config.user_Type,
                    //@ts-ignore
                    regType :photoOrg.config.regType,
                    returnUser :''
                }
            }
        }

        //@ts-ignore
        const config = photoOrg.config;
        //Added the condition for amazon omniture
        if(config.partnerAccountId){
            pageInfo.userInfo.profile.profileInfo.amazonAccountId = config.partnerAccountId
        }
        if(config.days_since_last_purchase != null &&
            config.days_since_last_purchase.indexOf('days_since_last_purchase') == -1 && 
            config.days_since_last_purchase >=0 ){
            pageInfo.userInfo.profile.profileInfo.daysSinceLastPurchase = config.days_since_last_purchase
        }
        if(config.login_type && config.login_type.indexOf('login_type') == -1){   
            pageInfo.userInfo.profile.profileInfo.loginType = config.login_type
        }
        if(config.reg_date && config.reg_date.indexOf('reg_date') == -1){
            pageInfo.userInfo.profile.profileInfo.regDate = Array.isArray(config.reg_date) ? config.reg_date[0] : config.reg_date
        }
        if(config.costco_user_flag && config.costco_user_flag.indexOf('d_costco_user_flag') == -1) {
            pageInfo.userInfo.profile.profileInfo.costcoUserFlag = config.costco_user_flag;
        }
        if(config.userPurchaseNumber && config.userPurchaseNumber.indexOf('d_costco_user_flag') == -1){ 
            pageInfo.userInfo.profile.profileInfo.userPurchaseNumber = config.userPurchaseNumber;
        }
        //@ts-ignore
        photoOrg.omniture = photoOrg.omniture || new Omniture(pageInfo);
}

const setProjectsOmniture = () => {
        try {
                updateGonFromStoreObject();
                set_projects_omniture();
        }catch(e){
            //@ts-ignore
            photoOrg.clientLogger.error({description: "PROJECTS:projects_view:setProjectsOmniture:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: e, err_stack: e.stack});
        }

    }

const App: React.FC = () => {
        const [globalError,setglobalError] = useState({noodle: "", errorId: "", show: false});
        
        useLayoutEffect(() => {
                setProjectsOmniture();
                try{
                    //@ts-ignore
                    photoOrg.Util.listenToFoundationOverlayOpenAndCloseForOmniture();
                }catch(e){}
        },[])

        //for adjusting the projects subheader height as global header height varies context wise
        const setHeaderHeight = () => {
                //@ts-ignore
                var softHeaderHeight = photoOrg.Util.getHeaderHeight();
                //@ts-ignore
                softHeaderHeight = photoOrg.Util.getStoreHeaderHeightfromSPA(softHeaderHeight);
                return softHeaderHeight;
        }
        const errorHandler =({ detail }) => { 
            console.log(detail); 
            if(!globalError.show){                                                       
                setglobalError(Object.assign({}, globalError, detail));
            }
        }
        
        document.removeEventListener(ActionTypes.ERROR_NOTIFY as any,errorHandler)
        document.addEventListener(ActionTypes.ERROR_NOTIFY as any, errorHandler)
        
        const hideErrorOverlay = () =>{
            setglobalError(Object.assign({}, globalError,{show:false}))
        }

        const ErrorFallbackComponentForApp = ({error, resetErrorBoundary}) => {
            if(!('IntersectionObserver' in window)){
                const body = [
                    //@ts-ignore
                    photoOrg.translations.projects["old_browser_txt1"],
                    //@ts-ignore
                    photoOrg.translations.projects["old_browser_txt2"]
                ]
                return (<div><MessageTextDisplayComponent {...{description:"", title: "", body}}/></div>);
            }
            return null;
        }
                   
        const LogRenderingError = (error, info) => {
            // @ts-ignore
            photoOrg.clientLogger.error({description: "LIBRARY:App:myErrorHandler:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
        }
        return (  
                <React.Fragment>
                        <ErrorBoundary FallbackComponent={ErrorFallbackComponentForApp} onError={LogRenderingError}>

                            <div id="scrollableDiv" role="main" className="po_projects" style={{WebkitOverflowScrolling: "touch",top: setHeaderHeight()}}>
                            <SubHeader></SubHeader>
                                <div className="projectsView" style={{"marginTop":"50px"}}>

                                <div className="clearfix"></div>

                                <div className="projectsTilesView row">
                                    <Switch>
                                            <Route exact path="/" key="saved-client">
                                                    <PortabilityBannerComponent />
                                                    <ProjectsComponent  tabName={ActionTypes.SAVED}></ProjectsComponent>
                                            </Route>
                                            <Route exact path="/saved" key="exact-saved-client">
                                                    <PortabilityBannerComponent />
                                                    <ProjectsComponent tabName={ActionTypes.SAVED}></ProjectsComponent>
                                            </Route>
                                            <Route exact path="/purchased" key="purchased-client">
                                                    <ProjectsComponent tabName={ActionTypes.PURCHASED}></ProjectsComponent>
                                            </Route>
                                            <Route exact path="/deleted" key="deleted-client">
                                                    <ProjectsComponent tabName={ActionTypes.DELETED}></ProjectsComponent>
                                            </Route>
                                    </Switch>
                                </div>
                            </div>
                            </div>
                            {/* @ts-ignore */}
                            <ErrorPortalComponent globalError={globalError} hideErrorOverlay={hideErrorOverlay} translations={photoOrg.translations.projects}/>
                        </ErrorBoundary>
                </React.Fragment>
        ) 
}

export default App;